import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { ThreeDotsLoadingComponent } from './components/three-dots-loading/three-dots-loading.component';
import { MessageComponentComponent } from './components/message-component/message-component.component';
import { IssueModalComponent } from './components/issue-modal/issue-modal.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';

import { HostAppWidgetsModule } from '@aot/host-app-widgets-demo'; 

@NgModule({
  declarations: [
    SnackbarComponent,
    ThreeDotsLoadingComponent,
    MessageComponentComponent,
    IssueModalComponent,
    NumbersOnlyDirective
  ],
  imports: [
    CommonModule,
    OverlayModule,HostAppWidgetsModule
  ],
  exports: [
    SnackbarComponent,
    ThreeDotsLoadingComponent,
    NumbersOnlyDirective
  ]
})
export class SharedModule { }
